import {
  OnboardingConfirmationModal,
  OnboardingImage,
  OnboardingInput,
  OnboardingInstructions,
  OnboardingLink,
  OnboardingRefetch,
  OnboardingSection,
  OnboardingSelect,
  OnboardingStatus,
  OnboardingVideo,
} from "@/components/Onboarding";

interface IProps {
  property: IMatIntegrationConfigurationProperty;
}

const MatProperty = ({ property }: IProps) => {
  const renderProperty = () => {
    switch (property.type) {
      case "INSTRUCTIONS":
        return <OnboardingInstructions {...property} />;
      case "LINK":
        return <OnboardingLink {...property} />;
      case "INPUT":
        return <OnboardingInput {...property} />;
      case "SELECT":
        return <OnboardingSelect {...property} />;
      case "VIDEO":
        return <OnboardingVideo {...property} />;
      case "IMAGE":
        return <OnboardingImage {...property} />;
      case "SECTION":
        return <OnboardingSection {...property} />;
      case "STATUS":
        return <OnboardingStatus {...property} />;
      case "REFETCH":
        return <OnboardingRefetch />;
      case "CONFIRMATION_MODAL":
        return <OnboardingConfirmationModal {...property} />;
      default:
        return null;
    }
  };

  return renderProperty();
};

export default MatProperty;
